import { jsx as _jsx } from "react/jsx-runtime";
import { Login as UILogin } from "@bluframe/mightychroma-mightytool-ui";
const Login = ({ isLoading, onSubmit }) => (_jsx(UILogin, { isLoading: isLoading, onSubmitLogin: onSubmit }));
export default Login;
